import { Breadcrumb } from '../Breadcrumb';
import styles from './index.module.scss';

type TitleProps = {
  /** タイトルパターン */
  variant: 'title';
  /** 表示するタイトル文字列 */
  title: string;
};

type BreadcrumbProps = {
  /** パンくずリストパターン */
  variant: 'breadcrumb';
  /** パンくずリストの項目 */
  breadcrumbItems: React.ComponentProps<typeof Breadcrumb>['items'];
};

type Props = TitleProps | BreadcrumbProps;

/**
 * 各ページの上部に表示するヘッダーコンポーネント。
 * タイトル文字列を表示する `title` パターンと、
 * パンくずリストを表示する `breadcrumb` パターンの2種類をサポートする。
 */
export const PageHeader: React.FC<Props> = props => {
  if (props.variant === 'title') {
    return (
      <div className={`${styles.PageHeader} ${styles['PageHeader--title']}`}>
        <span className={styles.PageHeader__Title}>{props.title}</span>
      </div>
    );
  }

  return (
    <div className={`${styles.PageHeader} ${styles['PageHeader--breadcrumb']}`}>
      <Breadcrumb items={props.breadcrumbItems} />
    </div>
  );
};
